import React from 'react';
import styled from 'styled-components';

interface LogoProps {
  width?: string;
  height?: string;
}

const StyledImage = styled.img<LogoProps>`
  width: ${props => props.width || '60px'};
  height: ${props => props.height || '60px'};
  object-fit: contain;
`;

const Logo: React.FC<LogoProps> = ({ width, height }) => {
  return (
    <StyledImage 
      src="/images/teamLogos/Nomads-Ice-Hockey-Club.png" 
      alt="Nomads Ice Hockey Club Logo" 
      width={width} 
      height={height}
    />
  );
};

export default Logo; 